var map = {
	"./": 72812,
	"./App": 17391,
	"./App.css": 44050,
	"./App.test": 26029,
	"./App.test.js": 26029,
	"./App.tsx": 17391,
	"./App_ori": 48030,
	"./App_ori.tsx": 48030,
	"./Fonts.css": 34173,
	"./components/Context": 94324,
	"./components/Context.tsx": 94324,
	"./components/Context_ori": 36789,
	"./components/Context_ori.tsx": 36789,
	"./components/GlobalVar": 10581,
	"./components/GlobalVar.tsx": 10581,
	"./components/agents/AgentsCapabilitySections": 2732,
	"./components/agents/AgentsCapabilitySections.tsx": 2732,
	"./components/agents/AgentsHero": 1962,
	"./components/agents/AgentsHero.tsx": 1962,
	"./components/agents/AgentsIntroSection": 87601,
	"./components/agents/AgentsIntroSection.tsx": 87601,
	"./components/agents/AgentsPrimaryCta": 79202,
	"./components/agents/AgentsPrimaryCta.tsx": 79202,
	"./components/agents/AgentsProblemSection": 18420,
	"./components/agents/AgentsProblemSection.tsx": 18420,
	"./components/agents/AgentsProductSuiteSection": 43928,
	"./components/agents/AgentsProductSuiteSection.tsx": 43928,
	"./components/agents/AgentsVenueOverview": 9124,
	"./components/agents/AgentsVenueOverview.tsx": 9124,
	"./components/agents/AgentsVideoGallery": 31019,
	"./components/agents/AgentsVideoGallery.tsx": 31019,
	"./components/agents/AgentsWhyChooseSection": 82236,
	"./components/agents/AgentsWhyChooseSection.tsx": 82236,
	"./components/agents/agentsLocalePath": 92511,
	"./components/agents/agentsLocalePath.ts": 92511,
	"./components/content/BlogNews": 17938,
	"./components/content/BlogNews.tsx": 17938,
	"./components/content/DigitalHuman": 17236,
	"./components/content/DigitalHuman.tsx": 17236,
	"./components/content/DrugContent": 76206,
	"./components/content/DrugContent.tsx": 76206,
	"./components/content/DrugContent_ori": 5523,
	"./components/content/DrugContent_ori.tsx": 5523,
	"./components/content/JoinUs": 57191,
	"./components/content/JoinUs.tsx": 57191,
	"./components/content/MapLocations": 40645,
	"./components/content/MapLocations.tsx": 40645,
	"./components/content/NoContent": 67289,
	"./components/content/NoContent.tsx": 67289,
	"./components/content/NoContent_ori": 36862,
	"./components/content/NoContent_ori.tsx": 36862,
	"./components/content/ToolsOverview": 43171,
	"./components/content/ToolsOverview.tsx": 43171,
	"./components/display/Badges": 63488,
	"./components/display/Badges.tsx": 63488,
	"./components/display/Cards": 51879,
	"./components/display/Cards.tsx": 51879,
	"./components/display/Cards_ori": 18790,
	"./components/display/Cards_ori.tsx": 18790,
	"./components/display/Frame": 62101,
	"./components/display/Frame.tsx": 62101,
	"./components/display/ImageFormat": 39064,
	"./components/display/ImageFormat.tsx": 39064,
	"./components/display/Sections": 88059,
	"./components/display/Sections.tsx": 88059,
	"./components/display/SkeletonShimmer": 21508,
	"./components/display/SkeletonShimmer.tsx": 21508,
	"./components/display/TextFormat": 24308,
	"./components/display/TextFormat.tsx": 24308,
	"./components/education/EducationBlendVisual": 30903,
	"./components/education/EducationBlendVisual.tsx": 30903,
	"./components/education/EducationFrameworkSection": 76957,
	"./components/education/EducationFrameworkSection.tsx": 76957,
	"./components/education/EducationHealthBridgeSection": 25264,
	"./components/education/EducationHealthBridgeSection.tsx": 25264,
	"./components/education/EducationHero": 86456,
	"./components/education/EducationHero.tsx": 86456,
	"./components/education/EducationInstitutionSection": 79359,
	"./components/education/EducationInstitutionSection.tsx": 79359,
	"./components/education/EducationIntroSection": 80475,
	"./components/education/EducationIntroSection.tsx": 80475,
	"./components/education/EducationIntroVisual": 64436,
	"./components/education/EducationIntroVisual.tsx": 64436,
	"./components/education/EducationLearningLoopSection": 63875,
	"./components/education/EducationLearningLoopSection.tsx": 63875,
	"./components/education/EducationModuleDetailPanel": 2241,
	"./components/education/EducationModuleDetailPanel.tsx": 2241,
	"./components/education/EducationModulesSection": 63484,
	"./components/education/EducationModulesSection.tsx": 63484,
	"./components/education/EducationPracticeHeroPanel": 51517,
	"./components/education/EducationPracticeHeroPanel.tsx": 51517,
	"./components/education/EducationPrimaryCta": 12548,
	"./components/education/EducationPrimaryCta.tsx": 12548,
	"./components/education/EducationProblemSection": 98078,
	"./components/education/EducationProblemSection.tsx": 98078,
	"./components/education/EducationProductSuiteSection": 73890,
	"./components/education/EducationProductSuiteSection.tsx": 73890,
	"./components/education/EducationSolutionSection": 43920,
	"./components/education/EducationSolutionSection.tsx": 43920,
	"./components/education/EducationWhyMedicalSection": 45562,
	"./components/education/EducationWhyMedicalSection.tsx": 45562,
	"./components/education/educationHeroCallouts.css": 55448,
	"./components/education/educationHeroOrbit.css": 69223,
	"./components/education/educationHeroWaveform.css": 95338,
	"./components/education/educationLocalePath": 59281,
	"./components/education/educationLocalePath.ts": 59281,
	"./components/education/educationModulePreviewAssets": 10183,
	"./components/education/educationModulePreviewAssets.ts": 10183,
	"./components/education/educationSolutionVisual.css": 72058,
	"./components/health/HealthChildPageHeroAmbient": 24719,
	"./components/health/HealthChildPageHeroAmbient.tsx": 24719,
	"./components/health/HealthEcosystemMapSection": 5167,
	"./components/health/HealthEcosystemMapSection.tsx": 5167,
	"./components/health/HealthFaqItem": 86269,
	"./components/health/HealthFaqItem.tsx": 86269,
	"./components/health/HealthFaqSection": 62535,
	"./components/health/HealthFaqSection.tsx": 62535,
	"./components/health/HealthHero": 82142,
	"./components/health/HealthHero.tsx": 82142,
	"./components/health/HealthHeroLoopAmbient": 57650,
	"./components/health/HealthHeroLoopAmbient.tsx": 57650,
	"./components/health/HealthLifecycleHorizontalSelector": 90967,
	"./components/health/HealthLifecycleHorizontalSelector.tsx": 90967,
	"./components/health/HealthLifecycleMobileFlow": 87162,
	"./components/health/HealthLifecycleMobileFlow.tsx": 87162,
	"./components/health/HealthLifecyclePanel": 32080,
	"./components/health/HealthLifecyclePanel.tsx": 32080,
	"./components/health/HealthLifecycleSection": 95707,
	"./components/health/HealthLifecycleSection.tsx": 95707,
	"./components/health/HealthLifecycleStageCard": 87822,
	"./components/health/HealthLifecycleStageCard.tsx": 87822,
	"./components/health/HealthLifecycleStageChip": 42918,
	"./components/health/HealthLifecycleStageChip.tsx": 42918,
	"./components/health/HealthLifecycleStageSelector": 45043,
	"./components/health/HealthLifecycleStageSelector.tsx": 45043,
	"./components/health/HealthLifecycleTimeline": 95193,
	"./components/health/HealthLifecycleTimeline.tsx": 95193,
	"./components/health/HealthLoopDiagram": 68565,
	"./components/health/HealthLoopDiagram.tsx": 68565,
	"./components/health/HealthPrimaryCta": 91318,
	"./components/health/HealthPrimaryCta.tsx": 91318,
	"./components/health/HealthProblemSection": 97144,
	"./components/health/HealthProblemSection.tsx": 97144,
	"./components/health/HealthProductCapabilityRow": 73867,
	"./components/health/HealthProductCapabilityRow.tsx": 73867,
	"./components/health/HealthProductGroupCard": 5414,
	"./components/health/HealthProductGroupCard.tsx": 5414,
	"./components/health/HealthProductPreview": 43321,
	"./components/health/HealthProductPreview.tsx": 43321,
	"./components/health/HealthProductStatusBadge": 6878,
	"./components/health/HealthProductStatusBadge.tsx": 6878,
	"./components/health/HealthProductSuiteIcons": 58127,
	"./components/health/HealthProductSuiteIcons.tsx": 58127,
	"./components/health/HealthProductSuiteSection": 52156,
	"./components/health/HealthProductSuiteSection.tsx": 52156,
	"./components/health/HealthSecondarySolutions": 25772,
	"./components/health/HealthSecondarySolutions.tsx": 25772,
	"./components/health/HealthSection": 36417,
	"./components/health/HealthSection.tsx": 36417,
	"./components/health/HealthSectionHeader": 32102,
	"./components/health/HealthSectionHeader.tsx": 32102,
	"./components/health/HealthSolutionSection": 55434,
	"./components/health/HealthSolutionSection.tsx": 55434,
	"./components/health/HealthUnitIntro": 26360,
	"./components/health/HealthUnitIntro.tsx": 26360,
	"./components/health/HealthVisualMarks": 3402,
	"./components/health/HealthVisualMarks.tsx": 3402,
	"./components/health/aimmaDoctor/AimmaDoctorPage": 19870,
	"./components/health/aimmaDoctor/AimmaDoctorPage.tsx": 19870,
	"./components/health/aimmaDoctor/HealthClinicalAgentDetailPanel": 63716,
	"./components/health/aimmaDoctor/HealthClinicalAgentDetailPanel.tsx": 63716,
	"./components/health/aimmaDoctor/HealthClinicalAgentTabSelector": 25793,
	"./components/health/aimmaDoctor/HealthClinicalAgentTabSelector.tsx": 25793,
	"./components/health/aimmaDoctor/HealthClinicalAgentsSection": 62727,
	"./components/health/aimmaDoctor/HealthClinicalAgentsSection.tsx": 62727,
	"./components/health/aimmaDoctor/HealthClinicalJourneySection": 96155,
	"./components/health/aimmaDoctor/HealthClinicalJourneySection.tsx": 96155,
	"./components/health/aimmaDoctor/HealthIntegrationEcosystemSection": 94374,
	"./components/health/aimmaDoctor/HealthIntegrationEcosystemSection.tsx": 94374,
	"./components/health/aimmaDoctor/HealthPhysicianControlSection": 22609,
	"./components/health/aimmaDoctor/HealthPhysicianControlSection.tsx": 22609,
	"./components/health/aimmaDoctor/HealthSoapWorkflowSection": 83394,
	"./components/health/aimmaDoctor/HealthSoapWorkflowSection.tsx": 83394,
	"./components/health/aimmaDoctor/HealthWhyDoctorSection": 48137,
	"./components/health/aimmaDoctor/HealthWhyDoctorSection.tsx": 48137,
	"./components/health/aimmaDoctor/healthAimmaDoctorAgentPreviewAssets": 52509,
	"./components/health/aimmaDoctor/healthAimmaDoctorAgentPreviewAssets.ts": 52509,
	"./components/health/aimmaDoctor/healthLocalePath": 78650,
	"./components/health/aimmaDoctor/healthLocalePath.ts": 78650,
	"./components/health/aimmaNurse/AimmaNursePage": 68508,
	"./components/health/aimmaNurse/AimmaNursePage.tsx": 68508,
	"./components/health/aimmaNurse/DoctorDashboardMiniPreview": 86418,
	"./components/health/aimmaNurse/DoctorDashboardMiniPreview.tsx": 86418,
	"./components/health/aimmaNurse/HealthIntegrationPreviewCard": 52075,
	"./components/health/aimmaNurse/HealthIntegrationPreviewCard.tsx": 52075,
	"./components/health/aimmaNurse/HealthNurseIntegrationPreviews": 30891,
	"./components/health/aimmaNurse/HealthNurseIntegrationPreviews.tsx": 30891,
	"./components/health/aimmaNurse/HealthNursingCoordinationPreviews": 76731,
	"./components/health/aimmaNurse/HealthNursingCoordinationPreviews.tsx": 76731,
	"./components/health/aimmaNurse/HealthNursingCoordinationSection": 13507,
	"./components/health/aimmaNurse/HealthNursingCoordinationSection.tsx": 13507,
	"./components/health/aimmaNurse/HealthNursingJourneySection": 79900,
	"./components/health/aimmaNurse/HealthNursingJourneySection.tsx": 79900,
	"./components/health/aimmaNurse/HealthNursingModuleDetailPanel": 95698,
	"./components/health/aimmaNurse/HealthNursingModuleDetailPanel.tsx": 95698,
	"./components/health/aimmaNurse/HealthNursingModulesSection": 39673,
	"./components/health/aimmaNurse/HealthNursingModulesSection.tsx": 39673,
	"./components/health/aimmaNurse/HealthWhyNurseSection": 71885,
	"./components/health/aimmaNurse/HealthWhyNurseSection.tsx": 71885,
	"./components/health/aimmaNurse/NurseBedsideTabletPreview": 64122,
	"./components/health/aimmaNurse/NurseBedsideTabletPreview.tsx": 64122,
	"./components/health/aimmaNurse/PatientIntakeMobilePreview": 53790,
	"./components/health/aimmaNurse/PatientIntakeMobilePreview.tsx": 53790,
	"./components/health/aimmaNurse/healthAimmaNursePreviewAssets": 57676,
	"./components/health/aimmaNurse/healthAimmaNursePreviewAssets.ts": 57676,
	"./components/health/aimmaPatient/AimmaPatientPage": 69892,
	"./components/health/aimmaPatient/AimmaPatientPage.tsx": 69892,
	"./components/health/aimmaPatient/HealthChildPageHeroBackdrop": 6318,
	"./components/health/aimmaPatient/HealthChildPageHeroBackdrop.tsx": 6318,
	"./components/health/aimmaPatient/HealthPatientJourneySection": 62809,
	"./components/health/aimmaPatient/HealthPatientJourneySection.tsx": 62809,
	"./components/health/aimmaPatient/HealthPatientModuleDetailPanel": 10981,
	"./components/health/aimmaPatient/HealthPatientModuleDetailPanel.tsx": 10981,
	"./components/health/aimmaPatient/HealthPatientModulesSection": 12480,
	"./components/health/aimmaPatient/HealthPatientModulesSection.tsx": 12480,
	"./components/health/aimmaPatient/HealthWhyPatientSection": 79805,
	"./components/health/aimmaPatient/HealthWhyPatientSection.tsx": 79805,
	"./components/health/aimmaPatient/healthAimmaPatientPreviewAssets": 45036,
	"./components/health/aimmaPatient/healthAimmaPatientPreviewAssets.ts": 45036,
	"./components/health/healthChildPageHeroAmbient.css": 58204,
	"./components/health/healthHeroLoopMotion.css": 89157,
	"./components/health/healthLayout": 38076,
	"./components/health/healthLayout.ts": 38076,
	"./components/health/healthLifecycleConstants": 39431,
	"./components/health/healthLifecycleConstants.ts": 39431,
	"./components/health/healthNavOffset": 97562,
	"./components/health/healthNavOffset.ts": 97562,
	"./components/health/healthProductPreviewAssets": 34646,
	"./components/health/healthProductPreviewAssets.ts": 34646,
	"./components/health/healthScroll": 17383,
	"./components/health/healthScroll.ts": 17383,
	"./components/health/healthTypes": 49613,
	"./components/health/healthTypes.ts": 49613,
	"./components/health/healthVisualStyles": 61340,
	"./components/health/healthVisualStyles.ts": 61340,
	"./components/navigation/Footer": 59929,
	"./components/navigation/Footer.tsx": 59929,
	"./components/navigation/Footer_ori": 81564,
	"./components/navigation/Footer_ori.tsx": 81564,
	"./components/navigation/NavBar": 34730,
	"./components/navigation/NavBar.tsx": 34730,
	"./components/navigation/NavBar_ori": 84331,
	"./components/navigation/NavBar_ori.tsx": 84331,
	"./components/navigation/NavDisplays": 18272,
	"./components/navigation/NavDisplays.tsx": 18272,
	"./components/navigation/NavDisplays_ori": 41969,
	"./components/navigation/NavDisplays_ori.tsx": 41969,
	"./components/navigation/NavLinkPages": 55125,
	"./components/navigation/NavLinkPages.tsx": 55125,
	"./components/navigation/NavLinkPages_ori": 77816,
	"./components/navigation/NavLinkPages_ori.tsx": 77816,
	"./components/navigation/businessUnitNavLogos": 98399,
	"./components/navigation/businessUnitNavLogos.ts": 98399,
	"./components/navigation/navPathUtils": 96579,
	"./components/navigation/navPathUtils.ts": 96579,
	"./components/pages/About/AIPlatforms": 25248,
	"./components/pages/About/AIPlatforms.tsx": 25248,
	"./components/pages/About/About": 52677,
	"./components/pages/About/About.tsx": 52677,
	"./components/pages/About/Ardi": 32064,
	"./components/pages/About/Ardi.tsx": 32064,
	"./components/pages/About/Atom": 70632,
	"./components/pages/About/Atom.tsx": 70632,
	"./components/pages/Agents": 35880,
	"./components/pages/Agents.tsx": 35880,
	"./components/pages/Blog": 40662,
	"./components/pages/Blog.tsx": 40662,
	"./components/pages/Careers": 23369,
	"./components/pages/Careers.tsx": 23369,
	"./components/pages/Core": 72435,
	"./components/pages/Core.tsx": 72435,
	"./components/pages/Drugomics": 58023,
	"./components/pages/Drugomics.tsx": 58023,
	"./components/pages/Education": 58422,
	"./components/pages/Education.tsx": 58422,
	"./components/pages/Energy": 40076,
	"./components/pages/Energy.tsx": 40076,
	"./components/pages/Finance": 83050,
	"./components/pages/Finance.tsx": 83050,
	"./components/pages/Health": 51036,
	"./components/pages/Health.tsx": 51036,
	"./components/pages/Homepage": 99118,
	"./components/pages/Homepage.tsx": 99118,
	"./components/pages/Manufacturing": 75854,
	"./components/pages/Manufacturing.tsx": 75854,
	"./components/pages/Mobility": 85369,
	"./components/pages/Mobility.tsx": 85369,
	"./components/pages/Newsroom": 14406,
	"./components/pages/Newsroom.tsx": 14406,
	"./components/pages/Robotics": 72237,
	"./components/pages/Robotics.tsx": 72237,
	"./components/pages/Robotics_old": 70839,
	"./components/pages/Robotics_old.tsx": 70839,
	"./components/pages/Security": 25260,
	"./components/pages/Security.tsx": 25260,
	"./components/tools/Animations": 46284,
	"./components/tools/Animations.tsx": 46284,
	"./components/tools/Buttons": 84458,
	"./components/tools/Buttons.tsx": 84458,
	"./components/tools/Viewer": 75679,
	"./components/tools/Viewer.tsx": 75679,
	"./data/TEMPLATE": 16084,
	"./data/TEMPLATE.json": 16084,
	"./data/aiSolutions": 32076,
	"./data/aiSolutions.json": 32076,
	"./data/aiSolutions_old": 15046,
	"./data/aiSolutions_old.json": 15046,
	"./data/aiTools": 94395,
	"./data/aiTools.json": 94395,
	"./data/aiTools_old": 43109,
	"./data/aiTools_old.json": 43109,
	"./data/badgesUnits": 18245,
	"./data/badgesUnits.json": 18245,
	"./data/businessUnits": 79287,
	"./data/businessUnits.json": 79287,
	"./data/businessUnits_old": 41665,
	"./data/businessUnits_old.json": 41665,
	"./data/content/about/AIPlatformContent": 83452,
	"./data/content/about/AIPlatformContent.json": 83452,
	"./data/content/about/AIPlatformContent_old": 52182,
	"./data/content/about/AIPlatformContent_old.json": 52182,
	"./data/content/about/aboutContent": 452,
	"./data/content/about/aboutContent.json": 452,
	"./data/content/about/aboutContent_old": 74574,
	"./data/content/about/aboutContent_old.json": 74574,
	"./data/content/about/ardi/ardiContent": 19528,
	"./data/content/about/ardi/ardiContent.json": 19528,
	"./data/content/about/ardi/ardiContent_old": 32914,
	"./data/content/about/ardi/ardiContent_old.json": 32914,
	"./data/content/about/ardi/ardiTools": 44714,
	"./data/content/about/ardi/ardiTools.json": 44714,
	"./data/content/about/ardi/ardiTools_old": 63580,
	"./data/content/about/ardi/ardiTools_old.json": 63580,
	"./data/content/about/atom/atomContent": 71770,
	"./data/content/about/atom/atomContent.json": 71770,
	"./data/content/about/atom/atomContent_old": 61132,
	"./data/content/about/atom/atomContent_old.json": 61132,
	"./data/content/about/atom/atomTools": 86184,
	"./data/content/about/atom/atomTools.json": 86184,
	"./data/content/about/atom/atomTools_old": 99058,
	"./data/content/about/atom/atomTools_old.json": 99058,
	"./data/content/agents/agentsContent": 89318,
	"./data/content/agents/agentsContent.json": 89318,
	"./data/content/blog/blogContent": 34642,
	"./data/content/blog/blogContent.json": 34642,
	"./data/content/blog/blogContent_old": 51348,
	"./data/content/blog/blogContent_old.json": 51348,
	"./data/content/careers/careersContent": 34140,
	"./data/content/careers/careersContent.json": 34140,
	"./data/content/careers/careersContent_old": 40918,
	"./data/content/careers/careersContent_old.json": 40918,
	"./data/content/careers/openPositions": 64352,
	"./data/content/careers/openPositions.json": 64352,
	"./data/content/careers/openPositions_old": 82714,
	"./data/content/careers/openPositions_old.json": 82714,
	"./data/content/core/coreContent": 86764,
	"./data/content/core/coreContent.json": 86764,
	"./data/content/core/coreContent_old": 26566,
	"./data/content/core/coreContent_old.json": 26566,
	"./data/content/drugomics/drugPipeline": 46612,
	"./data/content/drugomics/drugPipeline.json": 46612,
	"./data/content/drugomics/drugPipelineContent": 24917,
	"./data/content/drugomics/drugPipelineContent.json": 24917,
	"./data/content/drugomics/drugPipeline_old": 67902,
	"./data/content/drugomics/drugPipeline_old.json": 67902,
	"./data/content/drugomics/drugPipeline_old2": 88992,
	"./data/content/drugomics/drugPipeline_old2.json": 88992,
	"./data/content/drugomics/drugPipeline_ori": 59227,
	"./data/content/drugomics/drugPipeline_ori.json": 59227,
	"./data/content/drugomics/drugServices": 51970,
	"./data/content/drugomics/drugServices.json": 51970,
	"./data/content/drugomics/drugServicesContent": 1911,
	"./data/content/drugomics/drugServicesContent.json": 1911,
	"./data/content/drugomics/drugServicesContent_old": 65729,
	"./data/content/drugomics/drugServicesContent_old.json": 65729,
	"./data/content/drugomics/drugServices_old": 9828,
	"./data/content/drugomics/drugServices_old.json": 9828,
	"./data/content/drugomics/drugomicsContent": 14044,
	"./data/content/drugomics/drugomicsContent.json": 14044,
	"./data/content/drugomics/drugomicsContent_old": 93174,
	"./data/content/drugomics/drugomicsContent_old.json": 93174,
	"./data/content/education/educationContent": 14232,
	"./data/content/education/educationContent.json": 14232,
	"./data/content/education/medicalSenseiContent": 64000,
	"./data/content/education/medicalSenseiContent.json": 64000,
	"./data/content/energy/energyContent": 28230,
	"./data/content/energy/energyContent.json": 28230,
	"./data/content/energy/energyContent_old": 72120,
	"./data/content/energy/energyContent_old.json": 72120,
	"./data/content/finance/financeContent": 53268,
	"./data/content/finance/financeContent.json": 53268,
	"./data/content/finance/financeContent_old": 3422,
	"./data/content/finance/financeContent_old.json": 3422,
	"./data/content/health/aimmaDoctorContent": 88946,
	"./data/content/health/aimmaDoctorContent.json": 88946,
	"./data/content/health/aimmaNurseContent": 10996,
	"./data/content/health/aimmaNurseContent.json": 10996,
	"./data/content/health/aimmaPatientContent": 42064,
	"./data/content/health/aimmaPatientContent.json": 42064,
	"./data/content/health/healthContent": 93122,
	"./data/content/health/healthContent.json": 93122,
	"./data/content/homepage/allSolutionsContent": 37257,
	"./data/content/homepage/allSolutionsContent.json": 37257,
	"./data/content/homepage/allSolutionsContent_old": 62675,
	"./data/content/homepage/allSolutionsContent_old.json": 62675,
	"./data/content/homepage/homepageContent": 87494,
	"./data/content/homepage/homepageContent.json": 87494,
	"./data/content/homepage/homepageContent_old": 53464,
	"./data/content/homepage/homepageContent_old.json": 53464,
	"./data/content/homepage/locationPins": 92846,
	"./data/content/homepage/locationPins.json": 92846,
	"./data/content/homepage/locationPins_old": 85200,
	"./data/content/homepage/locationPins_old.json": 85200,
	"./data/content/manufacturing/manufacturingContent": 15352,
	"./data/content/manufacturing/manufacturingContent.json": 15352,
	"./data/content/manufacturing/manufacturingContent_old": 77026,
	"./data/content/manufacturing/manufacturingContent_old.json": 77026,
	"./data/content/mobility/mobilityContent": 44624,
	"./data/content/mobility/mobilityContent.json": 44624,
	"./data/content/mobility/mobilityContent_old": 32778,
	"./data/content/mobility/mobilityContent_old.json": 32778,
	"./data/content/newsroom/newsContent": 63675,
	"./data/content/newsroom/newsContent.json": 63675,
	"./data/content/newsroom/newsContent_old": 32037,
	"./data/content/newsroom/newsContent_old.json": 32037,
	"./data/content/robotics/aiiaModels": 7740,
	"./data/content/robotics/aiiaModels.json": 7740,
	"./data/content/robotics/aiiaModels_old": 80086,
	"./data/content/robotics/aiiaModels_old.json": 80086,
	"./data/content/robotics/aiiaRoles": 95147,
	"./data/content/robotics/aiiaRoles.json": 95147,
	"./data/content/robotics/aiiaRoles_old": 91637,
	"./data/content/robotics/aiiaRoles_old.json": 91637,
	"./data/content/robotics/applicationAreas": 93630,
	"./data/content/robotics/applicationAreas.json": 93630,
	"./data/content/robotics/roboticsContent": 24040,
	"./data/content/robotics/roboticsContent.json": 24040,
	"./data/content/robotics/roboticsContent_old": 98738,
	"./data/content/robotics/roboticsContent_old.json": 98738,
	"./data/content/security/securityContent": 8466,
	"./data/content/security/securityContent.json": 8466,
	"./data/content/security/securityContent_old": 17140,
	"./data/content/security/securityContent_old.json": 17140,
	"./data/exploreSolutions": 41023,
	"./data/exploreSolutions.json": 41023,
	"./data/exploreSolutions_old": 69209,
	"./data/exploreSolutions_old.json": 69209,
	"./data/linksMap": 96891,
	"./data/linksMap.json": 96891,
	"./data/linksMap_old": 85925,
	"./data/linksMap_old.json": 85925,
	"./data/navUnits": 25842,
	"./data/navUnits.json": 25842,
	"./data/navUnits_old": 3508,
	"./data/navUnits_old.json": 3508,
	"./data/people": 69293,
	"./data/people.json": 69293,
	"./data/people_old": 40343,
	"./data/people_old.json": 40343,
	"./data/vocab": 78489,
	"./data/vocab.json": 78489,
	"./data/vocab_old": 10179,
	"./data/vocab_old.json": 10179,
	"./docs/Graphen Brochure dec 9 2024.pdf": 81018,
	"./functions/DataFunctions": 61347,
	"./functions/DataFunctions.tsx": 61347,
	"./functions/DisplayFunctions": 34633,
	"./functions/DisplayFunctions.tsx": 34633,
	"./functions/DisplayInfoFunctions": 68207,
	"./functions/DisplayInfoFunctions.tsx": 68207,
	"./functions/useDocumentTitle": 51694,
	"./functions/useDocumentTitle.ts": 51694,
	"./image/3d-graph-computer-illustration.jpg": 6985,
	"./image/Logo_agents.svg": 21676,
	"./image/Logo_auto.svg": 55847,
	"./image/Logo_core.svg": 81711,
	"./image/Logo_drug.svg": 99384,
	"./image/Logo_education.svg": 52408,
	"./image/Logo_energy.svg": 92102,
	"./image/Logo_finance.svg": 94572,
	"./image/Logo_genom.svg": 53008,
	"./image/Logo_graphen.svg": 55923,
	"./image/Logo_manufacture.svg": 14549,
	"./image/Logo_robotics.svg": 2185,
	"./image/Logo_security.svg": 30559,
	"./image/about/Ardi/NLP.jpg": 30499,
	"./image/about/Ardi/Reasoning.jpg": 22733,
	"./image/about/Ardi/Sense.jpg": 34736,
	"./image/about/Ardi/action1.jpg": 24710,
	"./image/about/Ardi/action2.jpg": 40561,
	"./image/about/Ardi/ai_analytics.png": 50882,
	"./image/about/Ardi/ai_cyber_4.jpg": 90124,
	"./image/about/Ardi/ai_explanation.png": 34091,
	"./image/about/Ardi/ai_finance_2.jpg": 50271,
	"./image/about/Ardi/ai_finance_3.jpg": 42210,
	"./image/about/Ardi/ai_finance_4.jpg": 27441,
	"./image/about/Ardi/ai_finance_front.jpg": 18084,
	"./image/about/Ardi/ai_learning.png": 16970,
	"./image/about/Ardi/ai_learning2.png": 1986,
	"./image/about/Ardi/ai_medical_3.jpg": 95809,
	"./image/about/Ardi/ai_pipeline.png": 1578,
	"./image/about/Ardi/ai_reasoning.png": 26094,
	"./image/about/Ardi/ardi_analytics.png": 8740,
	"./image/about/Ardi/ardi_components.jpg": 65574,
	"./image/about/Ardi/ardi_database.png": 69589,
	"./image/about/Ardi/ardi_database2.png": 18960,
	"./image/about/Ardi/ardi_kf_3.png": 59035,
	"./image/about/Ardi/brain-functions.png": 2933,
	"./image/about/Ardi/databaseuse.jpg": 99697,
	"./image/about/Ardi/emotion1.jpg": 8373,
	"./image/about/Ardi/emotion2.jpg": 67882,
	"./image/about/Ardi/emotion3.jpg": 80039,
	"./image/about/Ardi/emotion4.jpg": 25628,
	"./image/about/Ardi/fake-computer.jpg": 58637,
	"./image/about/Ardi/holistic.jpg": 91682,
	"./image/about/Ardi/knowledge1.png": 396,
	"./image/about/Ardi/knowledge2.jpg": 32631,
	"./image/about/Ardi/knowledge3.jpg": 68794,
	"./image/about/Ardi/knowledge4.jpg": 89481,
	"./image/about/Ardi/marketing.jpg": 23633,
	"./image/about/Ardi/person_sunglasses.jpg": 75837,
	"./image/about/Ardi/personality-gird.png": 78546,
	"./image/about/Ardi/personality1.jpg": 98044,
	"./image/about/Ardi/personality2.jpg": 82699,
	"./image/about/Ardi/personality4.jpg": 40277,
	"./image/about/Ardi/portfolio-3.jpg": 91029,
	"./image/about/Ardi/strategy.jpg": 74622,
	"./image/about/Ardi/strategy2.jpg": 50710,
	"./image/about/Ardi/videounderstanding.jpg": 47588,
	"./image/about/Ardi/workflow usecase.jpg": 85951,
	"./image/about/Ardi/workflow1.jpg": 29497,
	"./image/about/Ardi/workflow2.jpg": 14478,
	"./image/about/Atom/Atom_foundation.png": 38775,
	"./image/about/Atom/adme.png": 1705,
	"./image/about/Atom/antibody antigen affinity.png": 99440,
	"./image/about/Atom/antibody antigen contact.png": 71146,
	"./image/about/Atom/atom1.jpg": 70462,
	"./image/about/Atom/atom2.png": 64657,
	"./image/about/Atom/atomnetwork.jpg": 57985,
	"./image/about/Atom/atomoverview.png": 74994,
	"./image/about/Atom/diseaseprogress.png": 79857,
	"./image/about/Atom/diseaseriskeval.png": 43319,
	"./image/about/Atom/drug and target.png": 96986,
	"./image/about/Atom/drugresistance.png": 68793,
	"./image/about/Atom/functionprediction.png": 7987,
	"./image/about/Atom/genomevariantreasoning.png": 32521,
	"./image/about/Atom/modular interaction.png": 17928,
	"./image/about/Atom/molgan.png": 88858,
	"./image/about/Atom/multiomicsnetwork.png": 53242,
	"./image/about/Atom/mutationidentification.png": 82431,
	"./image/about/Atom/pathwaynetwork.png": 30796,
	"./image/about/Atom/pp co simulation.png": 4427,
	"./image/about/Atom/protein binding site.png": 96067,
	"./image/about/Atom/protein force field.png": 16178,
	"./image/about/Atom/protein function prediction.png": 50532,
	"./image/about/Atom/protein structure simulation.jpg": 54607,
	"./image/about/Atom/racedifference.png": 48378,
	"./image/about/Atom/singlecellanalysis.png": 34790,
	"./image/about/Atom/virus_graph.gif": 68847,
	"./image/about/aiPlatforms/agni3.png": 7727,
	"./image/about/aiPlatforms/ai_cyber_4.jpg": 62388,
	"./image/about/aiPlatforms/ai_finance_1.jpg": 4696,
	"./image/about/aiPlatforms/ai_finance_2.jpg": 37543,
	"./image/about/aiPlatforms/ai_finance_3.jpg": 25386,
	"./image/about/aiPlatforms/ai_finance_4.jpg": 11129,
	"./image/about/aiPlatforms/aicaimage1.png": 13559,
	"./image/about/aiPlatforms/aicaimage2.png": 12924,
	"./image/about/aiPlatforms/aicaimage3.png": 42341,
	"./image/about/aiPlatforms/aicaimage4.png": 57674,
	"./image/about/aiPlatforms/alice1.png": 19576,
	"./image/about/aiPlatforms/alice2.jpg": 91371,
	"./image/about/aiPlatforms/alice3.png": 43306,
	"./image/about/futuristic-business-scene.jpg": 24606,
	"./image/about/group-of-young-people.jpeg": 6761,
	"./image/about/group_pic.jpeg": 38567,
	"./image/about/technologies/ai_ardi_front.jpg": 76726,
	"./image/about/technologies/ai_cyber_front.jpg": 89315,
	"./image/about/technologies/alpha-finance.jpg": 82266,
	"./image/about/technologies/atom-med.jpg": 11805,
	"./image/about/technologies/carrepair.jpg": 166,
	"./image/about/technologies/energy1.jpg": 81618,
	"./image/about/technologies/glowing-blue-cyborg.jpg": 69284,
	"./image/astral-wallpapers.jpg": 22979,
	"./image/banner.jpg": 13088,
	"./image/blog/AMOS.png": 25563,
	"./image/blog/Atom_foundation.png": 13514,
	"./image/blog/ai-summit-22.jpeg": 2041,
	"./image/blog/aiBestFriend.jpg": 80528,
	"./image/blog/aiCompanion.jpg": 10695,
	"./image/blog/aiDumpling.png": 70543,
	"./image/blog/aiEvolution.jpg": 15594,
	"./image/blog/ardi-brain.png": 87620,
	"./image/blog/digital-daniel.png": 18727,
	"./image/blog/digitalDaniel.png": 11722,
	"./image/blog/finance_force_network.png": 3646,
	"./image/blog/genome-force-network.png": 34667,
	"./image/blog/graph.png": 72971,
	"./image/blog/lackImg.png": 49763,
	"./image/blog/professional-woman-working-night.jpg": 19260,
	"./image/blog/susan-ava.png": 99500,
	"./image/core/abstract-ai-brain-vintage-art.jpg": 83989,
	"./image/core/aiassistant1.jpg": 48199,
	"./image/core/aiassistant2.jpg": 68216,
	"./image/core/aiassistant3.jpg": 72533,
	"./image/core/aiassistant4.jpg": 36910,
	"./image/core/medical-technology.jpg": 27988,
	"./image/digital-art-ai-technology.jpg": 35482,
	"./image/drugomics/0_0-1.jpeg": 42804,
	"./image/drugomics/3dots.svg": 22281,
	"./image/drugomics/Chevron left.svg": 92158,
	"./image/drugomics/Chevrons right.svg": 38472,
	"./image/drugomics/Clock.svg": 51016,
	"./image/drugomics/Dollar sign.svg": 47927,
	"./image/drugomics/Drug Development.png": 65487,
	"./image/drugomics/Drugomics banner video-small.mp4": 36339,
	"./image/drugomics/Fibrosis1.png": 10314,
	"./image/drugomics/Fibrosis2.png": 59297,
	"./image/drugomics/Fibrosis3.png": 74680,
	"./image/drugomics/Fibrosis4-1.png": 94705,
	"./image/drugomics/Fibrosis4-2.png": 18458,
	"./image/drugomics/Fibrosis4.png": 66199,
	"./image/drugomics/HE.png": 10095,
	"./image/drugomics/HE1.png": 85334,
	"./image/drugomics/HE2.png": 66957,
	"./image/drugomics/HE3.png": 27012,
	"./image/drugomics/HE4.png": 8667,
	"./image/drugomics/OA1.png": 66013,
	"./image/drugomics/OA2.png": 24774,
	"./image/drugomics/OA3-1.png": 82905,
	"./image/drugomics/OA3-2.png": 43170,
	"./image/drugomics/OA3.png": 63791,
	"./image/drugomics/OA4-1.png": 43438,
	"./image/drugomics/OA4-2.png": 62213,
	"./image/drugomics/OA4.png": 20944,
	"./image/drugomics/OA5.png": 17849,
	"./image/drugomics/Pie chart.svg": 1836,
	"./image/drugomics/SFO.png": 23614,
	"./image/drugomics/SFO1.png": 25189,
	"./image/drugomics/SFO2.png": 53390,
	"./image/drugomics/SFO3.png": 96407,
	"./image/drugomics/SFO4.png": 4888,
	"./image/drugomics/Vaccine development.png": 32722,
	"./image/drugomics/biomedical-engineer.jpg": 83547,
	"./image/drugomics/biomedical-student-working.jpg": 24553,
	"./image/drugomics/busy-chef-preparing.jpg": 49707,
	"./image/drugomics/dna-robot-hand.jpg": 84340,
	"./image/drugomics/doctor-from-future.jpg": 77948,
	"./image/drugomics/drug-design-base.png": 79087,
	"./image/drugomics/drug-design-pill.png": 2321,
	"./image/drugomics/drug-illustration.png": 94337,
	"./image/drugomics/drug_1.png": 24020,
	"./image/drugomics/drugomics.jpg": 60457,
	"./image/drugomics/focused-female-scientist.jpg": 5191,
	"./image/drugomics/male-pharmacist.jpg": 39450,
	"./image/drugomics/medicine-base.png": 66550,
	"./image/drugomics/medicine-helix.png": 87441,
	"./image/drugomics/medicine-illustration.png": 86019,
	"./image/drugomics/medicine_making.jpg": 78532,
	"./image/drugomics/mission.svg": 48296,
	"./image/drugomics/partnership.svg": 36678,
	"./image/drugomics/personalized medicine.png": 24814,
	"./image/drugomics/pill-shiny.jpg": 86513,
	"./image/drugomics/portrait-women-lab.jpg": 16928,
	"./image/drugomics/rocket.svg": 27690,
	"./image/drugomics/shakehand.svg": 24379,
	"./image/drugomics/solutions.svg": 32470,
	"./image/drugomics/vaccine-design-base.png": 46006,
	"./image/drugomics/vaccine-design-syringe.png": 20450,
	"./image/drugomics/vaccine-illustration.png": 28030,
	"./image/drugomics/vaccine_1.jpg": 72545,
	"./image/drugomics/women-lab-coat.jpeg": 62655,
	"./image/education/education-cover.png": 65075,
	"./image/education/education-hero-instructor.png": 95094,
	"./image/education/education-intro-coaching.png": 39341,
	"./image/education/education-solution-visual.png": 74108,
	"./image/education/medical-sensei/case-prep.png": 61595,
	"./image/education/medical-sensei/debate.png": 90612,
	"./image/education/medical-sensei/instructor.png": 65838,
	"./image/education/medical-sensei/reflection.png": 34528,
	"./image/education/medical-sensei/simulation.png": 98554,
	"./image/energy/digital-dashboard-monitoring.jpg": 87153,
	"./image/energy/other_nuclear_fusion.png": 97107,
	"./image/energy/tree-growing-from-motherboard.jpg": 56978,
	"./image/finance/NLP.jpg": 84193,
	"./image/finance/alpha1.png": 90046,
	"./image/finance/alpha3.png": 92908,
	"./image/finance/aml.jpg": 38357,
	"./image/finance/fraud4.png": 81517,
	"./image/finance/fraudprotection1.jpg": 61139,
	"./image/finance/futuristic-robot-interacting-with-money.jpg": 39759,
	"./image/finance/kyc1.jpg": 16219,
	"./image/finance/kyc2.jpg": 73420,
	"./image/finance/kyc3.jpg": 11465,
	"./image/finance/loan1.jpg": 85796,
	"./image/finance/loan2.jpg": 69491,
	"./image/finance/loan3.jpg": 14230,
	"./image/finance/marketintelligence1.jpg": 93669,
	"./image/finance/marketintelligence2.jpg": 5818,
	"./image/finance/marketintelligence3.jpg": 76983,
	"./image/finance/marketintelligence4.jpg": 70668,
	"./image/finance/personality1-1.png": 28332,
	"./image/finance/robotic-clerk.jpg": 71343,
	"./image/finance/trader1.jpg": 31410,
	"./image/finance/trader2.jpg": 41309,
	"./image/finance/trader3.jpg": 90176,
	"./image/finance/trader4.jpg": 73011,
	"./image/glowing-circuit-board.jpg": 61628,
	"./image/health/3d-representation-dna.jpg": 22932,
	"./image/health/Aimma_stage01.png": 57126,
	"./image/health/Aimma_stage02.png": 24541,
	"./image/health/Aimma_stage03.png": 3412,
	"./image/health/Aimma_stage04.png": 95403,
	"./image/health/Aimma_stage05.png": 31746,
	"./image/health/CongenitalMe7.jpg": 76318,
	"./image/health/FutureMe4.jpg": 13316,
	"./image/health/Get start.svg": 76294,
	"./image/health/Graphen_6vxx_movie.gif": 93795,
	"./image/health/How Do I Know.svg": 82712,
	"./image/health/Step 1 Know Yourself.svg": 72840,
	"./image/health/Step 2 Personalized Medicine.svg": 52453,
	"./image/health/Step 3 Stay Supported.svg": 18923,
	"./image/health/TodayMe.jpg": 15996,
	"./image/health/aimma-bedside-preview.png": 80656,
	"./image/health/aimma-doctor/aimma-chronicle-preview.png": 66841,
	"./image/health/aimma-doctor/aimma-diagnosis-preview.png": 44249,
	"./image/health/aimma-doctor/aimma-reminder-preview.png": 11704,
	"./image/health/aimma-doctor/aimma-reporting-preview.png": 11284,
	"./image/health/aimma-doctor/aimma-triage-preview.png": 77298,
	"./image/health/aimma-doctor/physician-dashboard-hero.png": 95087,
	"./image/health/aimma-kiosk-preview.png": 10117,
	"./image/health/aimma-nurse/aimma-notes-preview.png": 39375,
	"./image/health/aimma-nurse/nurse-bedside-tablet.png": 44164,
	"./image/health/aimma-patient/aimma-consult-preview.png": 80396,
	"./image/health/aimma-patient/aimma-interview-preview.png": 6221,
	"./image/health/aimma-patient/aimma-patient-hero-backdrop.png": 90596,
	"./image/health/aimma-patient/aimma-record-preview.png": 97899,
	"./image/health/aimma-patient/patient-intake-mobile.png": 5214,
	"./image/health/aimma_ai_powered_healthcare_coordination.png": 73210,
	"./image/health/aimma_shared_clinical_context_illustration.png": 5743,
	"./image/health/care-job-scene-with-patient.jpg": 41326,
	"./image/health/covid-19-viz-032020.jpg": 58229,
	"./image/health/doctor-from-future-concept.jpg": 48992,
	"./image/health/doctor-neon-skeleton-cropped.jpg": 18621,
	"./image/health/doctor-noen-skeleton.jpg": 6119,
	"./image/health/dot.svg": 32828,
	"./image/health/ecosystem-delivering-care.png": 12479,
	"./image/health/ecosystem-managing-orgs.png": 49010,
	"./image/health/ecosystem-receiving-care.png": 32248,
	"./image/health/ecosystem-safe-deployment.png": 23939,
	"./image/health/ecosystem-scaling-ecosystem.png": 90290,
	"./image/health/ecosystem-teaching-care.png": 78923,
	"./image/health/freepik__enhance__43990.png": 73342,
	"./image/health/freepik__expand__62550.png": 57537,
	"./image/health/freepik__expand__75085.png": 32266,
	"./image/health/freepik__white-clean-background-a-high-tech-dna-shape-in-bl__95498.mp4": 78918,
	"./image/health/health3.jpg": 43768,
	"./image/health/health4.jpg": 90507,
	"./image/health/healthcare-professionals-discussing-medication.jpg": 56342,
	"./image/health/image.png": 9802,
	"./image/health/medical-capsule-with-medical-concept-3d-rendering.jpg": 50897,
	"./image/health/medical-nurses-working-together-hospital.jpg": 54625,
	"./image/health/person-being-scanned-by-digital-health-app.jpg": 68509,
	"./image/health/problem-doctor-fragmented-workflow.png": 93530,
	"./image/health/solution.svg": 62422,
	"./image/health/story2.png": 56786,
	"./image/health/two-men-are-sitting-table-with-monitor-that-says-technology.jpg": 48251,
	"./image/health/woman-interacting-with-dna.jpg": 50681,
	"./image/health/zoey-hospital.png": 64967,
	"./image/icons/ADME Prediction.svg": 69053,
	"./image/icons/Affinity Prediction.svg": 99670,
	"./image/icons/Antibody Develoipability.svg": 72631,
	"./image/icons/Atom Network.svg": 66754,
	"./image/icons/Biology Networks.svg": 737,
	"./image/icons/Drug Generation.svg": 81109,
	"./image/icons/Heredity.svg": 54409,
	"./image/icons/Joint Injury.svg": 35418,
	"./image/icons/Molecular Interaction.svg": 34635,
	"./image/icons/Multi-Omics Analytics.svg": 86814,
	"./image/icons/Mutation Intelligence.svg": 72991,
	"./image/icons/Obesity.svg": 61684,
	"./image/icons/Progress Prediction.svg": 7893,
	"./image/icons/Protein Function.svg": 53216,
	"./image/icons/Protein Structure.svg": 52551,
	"./image/icons/age.svg": 61844,
	"./image/icons/ai_chip.svg": 96606,
	"./image/icons/alarm.svg": 63630,
	"./image/icons/analysis.svg": 7593,
	"./image/icons/assist.svg": 22978,
	"./image/icons/bags.svg": 7434,
	"./image/icons/book.svg": 83952,
	"./image/icons/cart.svg": 48005,
	"./image/icons/ch.svg": 58402,
	"./image/icons/checklist.svg": 66325,
	"./image/icons/computer.svg": 88288,
	"./image/icons/conversation.svg": 79002,
	"./image/icons/cowboy.svg": 35834,
	"./image/icons/customerSupport.svg": 42004,
	"./image/icons/discuss.svg": 7123,
	"./image/icons/dna.svg": 7414,
	"./image/icons/doctor.svg": 9078,
	"./image/icons/gene report.svg": 59902,
	"./image/icons/head.svg": 53721,
	"./image/icons/hk.svg": 49084,
	"./image/icons/info.svg": 81271,
	"./image/icons/joint.svg": 86813,
	"./image/icons/jp.svg": 68349,
	"./image/icons/like.svg": 22186,
	"./image/icons/navigation.svg": 97497,
	"./image/icons/network.svg": 45191,
	"./image/icons/pamplet.svg": 49016,
	"./image/icons/payement_integration.svg": 48111,
	"./image/icons/payment.svg": 82099,
	"./image/icons/pill.svg": 48054,
	"./image/icons/privacy.svg": 8749,
	"./image/icons/query.svg": 40553,
	"./image/icons/question.svg": 91767,
	"./image/icons/sing.svg": 61218,
	"./image/icons/tw.svg": 36324,
	"./image/icons/us.svg": 88091,
	"./image/icons/world.svg": 83017,
	"./image/logo_drugomic_nav.svg": 74150,
	"./image/logo_education_nav.svg": 13550,
	"./image/logo_health_nav.svg": 47262,
	"./image/logo_name.svg": 9283,
	"./image/logo_name_light.svg": 82786,
	"./image/manufacturing/candid-image-photography-with-natural.png": 43323,
	"./image/manufacturing/energy1.png": 29054,
	"./image/manufacturing/engineer-controlling-robotic-arm.jpg": 25738,
	"./image/manufacturing/factory-office-facility-chief-engineer-developer-holds.jpg": 47284,
	"./image/manufacturing/futurism-perspective-digital-nomads-lifestyle.jpg": 42645,
	"./image/manufacturing/green1.jpg": 7753,
	"./image/manufacturing/green2.jpg": 16254,
	"./image/manufacturing/green3.jpg": 36411,
	"./image/manufacturing/green4.jpg": 31528,
	"./image/manufacturing/laptop-with-graph-screen-word-graph-screen.jpg": 17683,
	"./image/manufacturing/man-is-using-tablet.jpg": 41012,
	"./image/manufacturing/man-is-working-computer-factory.jpg": 99093,
	"./image/manufacturing/portrait-engineers-work-hours-job-site-scale.jpg": 63228,
	"./image/manufacturing/portrait-engineers-work-hours-job-site.jpg": 6709,
	"./image/manufacturing/smart-warehouse-management-system-with-innovative-internet-things-technology.jpg": 39416,
	"./image/manufacturing/solar_monitoring_2.png": 10896,
	"./image/manufacturing/wind-turbine-engineer-reviewing-wind-data-charts-tablet.jpg": 81589,
	"./image/mobility/ai_car.jpg": 86279,
	"./image/mobility/aiassistant2.jpg": 50494,
	"./image/mobility/aiassistant3.jpg": 81979,
	"./image/mobility/aiassistant4.jpg": 51976,
	"./image/mobility/aiautomobile.jpg": 60751,
	"./image/mobility/autozone-overlay.png": 33778,
	"./image/mobility/car1.jpg": 95693,
	"./image/mobility/car3.jpg": 18175,
	"./image/mobility/cardoc2.jpg": 67494,
	"./image/mobility/cardoc3.jpg": 10627,
	"./image/mobility/collaboration-certified-engineers-auto-repair-shop-fix-service-broken-vehicle.jpg": 12530,
	"./image/mobility/man-driving.png": 38854,
	"./image/mobility/modern-car-futuristic-road.jpg": 95894,
	"./image/mobility/person-using-ar-technology.jpg": 8341,
	"./image/newsroom/20200429_6.png": 39163,
	"./image/newsroom/8clustertable.png": 30917,
	"./image/newsroom/Digital-Humans-and-Detecting-Disease-at-COMPUTEX-2025.png": 81627,
	"./image/newsroom/Graphen-Aiia-exhibiton-tw.jpeg": 62399,
	"./image/newsroom/Untitled.01.png": 32733,
	"./image/newsroom/ai-indonesia-asech.png": 64611,
	"./image/newsroom/ai-reward.jpeg": 19026,
	"./image/newsroom/ai-summit-2022.png": 12174,
	"./image/newsroom/aml.jpg": 63169,
	"./image/newsroom/ardi_kf_3.png": 81321,
	"./image/newsroom/cylin.jpg": 52314,
	"./image/newsroom/drugomics-debut.jpeg": 29992,
	"./image/newsroom/genome-force-network.png": 62435,
	"./image/newsroom/graph-cylin.png": 64669,
	"./image/newsroom/graphen-drugomics-presentation.jpeg": 65776,
	"./image/newsroom/hightech-conference-room-with-video-screens.jpg": 95415,
	"./image/newsroom/info.jpg": 63827,
	"./image/newsroom/lackImg.png": 92955,
	"./image/newsroom/mets-taiwan-day-2024.jpg": 86011,
	"./image/newsroom/whole-graph-0310.png": 75592,
	"./image/office_meeting_room.jpg": 82396,
	"./image/people/andrewwang.png": 69318,
	"./image/people/chenyong.jpg": 55833,
	"./image/people/chiaowenchen.jpeg": 59653,
	"./image/people/cylin.jpg": 96559,
	"./image/people/cylin_square.png": 1413,
	"./image/people/danielng.jpg": 15884,
	"./image/people/jerrychen.png": 36510,
	"./image/people/jessicaliu.jpg": 67720,
	"./image/people/johnhuang.png": 41100,
	"./image/people/kinweisoh.jpg": 98273,
	"./image/people/molalin.jpg": 24452,
	"./image/people/nathan.jpg": 32422,
	"./image/people/richardliang.jpg": 90040,
	"./image/people/tedmaejima.png": 66331,
	"./image/people/terence.jpg": 55962,
	"./image/people/tomwang.jpg": 97583,
	"./image/people/yitingchen.png": 55686,
	"./image/robotics/AI humanoids mission.png": 35358,
	"./image/robotics/Book open.svg": 45737,
	"./image/robotics/Compass.svg": 21800,
	"./image/robotics/Fast_forward.svg": 58864,
	"./image/robotics/Frame 3612.png": 59093,
	"./image/robotics/Globe.svg": 19919,
	"./image/robotics/Image.svg": 60943,
	"./image/robotics/Info.svg": 34068,
	"./image/robotics/Navigation.svg": 16086,
	"./image/robotics/Search.svg": 14164,
	"./image/robotics/Shopping cart.svg": 36358,
	"./image/robotics/Smile.svg": 69036,
	"./image/robotics/Star.svg": 95912,
	"./image/robotics/Tag.svg": 90456,
	"./image/robotics/Thumbs up.svg": 75842,
	"./image/robotics/Tool.svg": 15310,
	"./image/robotics/User.svg": 15817,
	"./image/robotics/Users.svg": 83880,
	"./image/robotics/Video.svg": 2777,
	"./image/robotics/agent.png": 75163,
	"./image/robotics/agents-intro-airport-kiosk.png": 80029,
	"./image/robotics/agents-why-choose.png": 48335,
	"./image/robotics/aiia.png": 54318,
	"./image/robotics/aiia_bg_cashier.png": 57060,
	"./image/robotics/aiia_frame.png": 26772,
	"./image/robotics/aiia_machine7.png": 55801,
	"./image/robotics/aiia_vid.mp4": 21571,
	"./image/robotics/aiter go.png": 52609,
	"./image/robotics/aiter one.png": 63055,
	"./image/robotics/attraction_aiia.png": 5142,
	"./image/robotics/avatar-lineup.png": 39933,
	"./image/robotics/black-podium-beneath-canopy-bioluminescent-trees.jpg": 28619,
	"./image/robotics/brain-robot-small1-1.jpg": 99826,
	"./image/robotics/building_aiia.png": 30895,
	"./image/robotics/building_checklist.png": 66227,
	"./image/robotics/building_video.png": 51442,
	"./image/robotics/chef.png": 65050,
	"./image/robotics/close-up-portrait-traveling-woman.jpg": 80732,
	"./image/robotics/comparison.png": 62861,
	"./image/robotics/customer-hardware-store-does-select-hammer-tool-showcase.png": 94300,
	"./image/robotics/daniel.png": 13439,
	"./image/robotics/elderly-woman-shopping-customer-day.jpg": 27819,
	"./image/robotics/electronic_aiia.png": 64769,
	"./image/robotics/electronic_builder.png": 53132,
	"./image/robotics/electronic_nav.png": 45954,
	"./image/robotics/electronic_staff.png": 92547,
	"./image/robotics/exmachina.jpg": 36854,
	"./image/robotics/freepik__expand__8375.png": 32369,
	"./image/robotics/furniture_aiia.png": 33863,
	"./image/robotics/furniture_bundled.png": 21335,
	"./image/robotics/furniture_image_based.png": 39996,
	"./image/robotics/furniture_shop.png": 92607,
	"./image/robotics/furniture_store.png": 32776,
	"./image/robotics/glenda.png": 52343,
	"./image/robotics/gordon.png": 44925,
	"./image/robotics/guest-hotel-is-ringing-bell-reception.jpg": 43131,
	"./image/robotics/hotel_check_in.png": 59685,
	"./image/robotics/hotel_facility.png": 97256,
	"./image/robotics/hotel_info.png": 27195,
	"./image/robotics/img_classic.png": 85800,
	"./image/robotics/img_glass.png": 35708,
	"./image/robotics/img_hologram.png": 77791,
	"./image/robotics/img_kiosk.png": 82489,
	"./image/robotics/img_tablet.png": 99902,
	"./image/robotics/keiji.png": 18,
	"./image/robotics/kiosk_classic.png": 90656,
	"./image/robotics/kiosk_frame.png": 31815,
	"./image/robotics/kiosk_glass.png": 54564,
	"./image/robotics/kiosk_group.png": 31089,
	"./image/robotics/kiosk_hologram.png": 29847,
	"./image/robotics/kiosk_tablet.png": 34102,
	"./image/robotics/kisok_kiosk.png": 777,
	"./image/robotics/lab.jpeg": 21746,
	"./image/robotics/male-executive-analyzing-graphs-digital-tablet-desk-coworking-space.jpg": 37313,
	"./image/robotics/mutilanguage.png": 85967,
	"./image/robotics/nav.png": 74695,
	"./image/robotics/online_order.png": 37442,
	"./image/robotics/qrcode.png": 22752,
	"./image/robotics/recommendation.png": 69607,
	"./image/robotics/recovery.png": 56987,
	"./image/robotics/restaurant_store.png": 83669,
	"./image/robotics/robot1.jpg": 46475,
	"./image/robotics/robot2.png": 32152,
	"./image/robotics/robot3.png": 16769,
	"./image/robotics/robotic-figure-with-glowing-orange-accents-contemplating-minimalist-setting-highlights-futuristic-design-advanced-technology.jpg": 9588,
	"./image/robotics/robotics lab 1.png": 39617,
	"./image/robotics/robotics lab 2.png": 90634,
	"./image/robotics/robotics lab 3.png": 45843,
	"./image/robotics/robotics lab 4.png": 45884,
	"./image/robotics/robotics lab 5.png": 75301,
	"./image/robotics/robotics_core_1.jpeg": 86408,
	"./image/robotics/robotics_core_2.jpeg": 11849,
	"./image/robotics/robotics_core_3.jpeg": 89634,
	"./image/robotics/room-with-couch-table-with-plant-it.jpg": 90541,
	"./image/robotics/sandy.png": 15419,
	"./image/robotics/store-with-many-items-shelves-including-microwave-toaster.jpg": 57637,
	"./image/robotics/store1.png": 72038,
	"./image/robotics/store3.jpg": 34192,
	"./image/robotics/store5.jpg": 67334,
	"./image/robotics/store_solution.jpg": 73517,
	"./image/robotics/story2.png": 55913,
	"./image/robotics/story3.png": 84736,
	"./image/robotics/story4.png": 59743,
	"./image/robotics/supermarket_question.png": 36950,
	"./image/robotics/supermarket_recipe.png": 14828,
	"./image/robotics/supermarket_shop.png": 43214,
	"./image/robotics/supermarket_translate.png": 6986,
	"./image/robotics/talking-to-aiia.png": 20129,
	"./image/robotics/trans_ticket.png": 39415,
	"./image/robotics/trans_trip.png": 86338,
	"./image/robotics/why robotics.png": 41707,
	"./image/robotics/zoey.png": 32705,
	"./image/security/ai_cyber_1.jpg": 90553,
	"./image/security/ai_cyber_2.jpg": 83438,
	"./image/security/ai_cyber_4.jpg": 38040,
	"./image/security/apt1.jpg": 82779,
	"./image/security/apt2.jpg": 39980,
	"./image/security/apt4.jpg": 48282,
	"./image/security/cyber-security-concept-digital-art.jpg": 25267,
	"./image/security/cybersecurity-green.jpg": 63850,
	"./image/security/monitoring1.jpg": 70630,
	"./image/security/monitoring2.jpg": 12049,
	"./image/security/monitoring3.jpg": 14676,
	"./image/security/monitoring4.jpg": 35487,
	"./image/security/security3.jpg": 80172,
	"./image/there-is-cow-space-suit-floating.png": 70219,
	"./index": 72812,
	"./index.css": 59555,
	"./index.d": 32232,
	"./index.d.ts": 32232,
	"./index.js": 72812,
	"./logo.svg": 69445,
	"./reportWebVitals": 89031,
	"./reportWebVitals.js": 89031,
	"./setupTests": 89472,
	"./setupTests.js": 89472,
	"./types": 86451,
	"./types.ts": 86451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13678;